import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const useAutoLogout = (timeoutMinutes = 60) => { // 300 minutes = 5 hours
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const logoutUser = () => {
    localStorage.removeItem("loginData"); // clear login info
    navigate("/login"); // redirect to login
    window.location.reload();
  };

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(logoutUser, timeoutMinutes * 60 * 1000); // minutes → ms
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // start timer

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
};
